var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.fileInfo)?_c(_setup.SharingTab,{attrs:{"file-info":_setup.fileInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }